export class HexaCoreCalculator {
  /**
   * 計算核心進度
   * @param {Object} coreLevels - 各核心等級
   * @param {Object} coreData - 核心數據
   * @returns {Object} - 計算結果
   */
  static calculateProgress(coreLevels, coreData) {
    // 計算不含共用核心的進度
    let currentFragmentsWithoutCommon = 0
    let totalFragmentsWithoutCommon = 0

    // 計算技能核心進度
    const skillFragments = coreData.skillCore.soulAlderFragment
    const skillWeight = skillFragments.reduce((a, b) => a + b, 0)
    totalFragmentsWithoutCommon += skillWeight * 2

    currentFragmentsWithoutCommon += this.calculateCurrentFragments(skillFragments, coreLevels.skillCore)
    currentFragmentsWithoutCommon += this.calculateCurrentFragments(skillFragments, coreLevels.skillCore2)

    // 技能核心 1：0→1 為免費（資料表用通用成本，因此在加總時扣回來）
    const skillCore1Level = coreLevels.skillCore
    if (skillCore1Level && skillCore1Level >= 1 && skillFragments.length > 0) {
      currentFragmentsWithoutCommon -= skillFragments[0]
      totalFragmentsWithoutCommon -= skillFragments[0]
    } else if (skillFragments.length > 0) {
      // 即使目前等級=0，總需求仍需扣除技能核心1的0→1免費成本
      totalFragmentsWithoutCommon -= skillFragments[0]
    }

    // 計算精通核心進度
    const masteryWeight = coreData.masteryCore.soulAlderFragment.reduce((a, b) => a + b, 0)
    totalFragmentsWithoutCommon += masteryWeight * 4
    for (let i = 1; i <= 4; i++) {
      currentFragmentsWithoutCommon += this.calculateCurrentFragments(
        coreData.masteryCore.soulAlderFragment,
        coreLevels[`masteryCore${i}`]
      )
    }

    // 計算強化核心進度
    const enhancementWeight = coreData.enhancementCore.soulAlderFragment.reduce((a, b) => a + b, 0)
    totalFragmentsWithoutCommon += enhancementWeight * 4
    for (let i = 1; i <= 4; i++) {
      currentFragmentsWithoutCommon += this.calculateCurrentFragments(
        coreData.enhancementCore.soulAlderFragment,
        coreLevels[`enhancementCore${i}`]
      )
    }

    // 計算含共用核心的進度
    const commonWeight = coreData.commonCore.soulAlderFragment.reduce((a, b) => a + b, 0)
    const totalFragments = totalFragmentsWithoutCommon + commonWeight
    const currentFragments = currentFragmentsWithoutCommon + 
      this.calculateCurrentFragments(coreData.commonCore.soulAlderFragment, coreLevels.commonCore)

    return {
      totalProgressWithoutCommon: (currentFragmentsWithoutCommon / totalFragmentsWithoutCommon) * 100,
      currentFragmentsWithoutCommon,
      totalFragmentsWithoutCommon,
      totalProgress: (currentFragments / totalFragments) * 100,
      currentFragments,
      totalFragments
    }
  }

  /**
   * 計算當前碎片數量
   * @param {Array} fragments - 碎片數據陣列
   * @param {number} level - 當前等級
   * @returns {number} - 當前碎片數量
   */
  static calculateCurrentFragments(fragments, level) {
    if (!level || level <= 0) return 0
    return fragments.slice(0, level).reduce((a, b) => a + b, 0)
  }

  /**
   * 驗證核心等級
   * @param {number} level - 要驗證的等級
   * @returns {number} - 修正後的等級
   */
  static validateCoreLevel(level) {
    if (level === '' || level === null || isNaN(level)) return 0
    return Math.max(0, Math.min(30, Math.floor(Number(level))))
  }
} 